import styled from '@emotion/styled'

export const FullHeightDiv = styled.div`
  overflow-y: auto;
  height: 100%;
`
